<div>
  <mat-form-field appearance="outline" floatLabel="always" class="date-field">
    <input
      matInput
      [errorStateMatcher]="startDatematcher"
      [matDatepicker]="picker1"
      [formControl]="startDateValue"
      (dateChange)="updateStartDate()"
    />
    <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
    <mat-datepicker #picker1></mat-datepicker>
    <mat-error *ngIf="startDateValue.hasError('startDateRequired')"> Start Date cannot be empty</mat-error>
    <mat-error *ngIf="startDateValue.hasError('startDateBeforeEndDate')">
      Start Date cannot be after End date</mat-error
    >
  </mat-form-field>
  <span class="span-margin">to</span>
  <span class="span-margin present-style" *ngIf="present" class="present-margin">Present</span>
  <mat-form-field appearance="outline" floatLabel="always" class="date-field" *ngIf="!present">
    <input
      matInput
      [errorStateMatcher]="endDatematcher"
      [matDatepicker]="picker2"
      [formControl]="endDateValue"
      (dateChange)="updateEndDate()"
    />
    <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
    <mat-datepicker #picker2></mat-datepicker>
    <mat-error *ngIf="endDateValue.hasError('endDateRequired')">
      End Date can not be empty. Please check "Present" if there is no End date</mat-error
    >
    <mat-error *ngIf="endDateValue.hasError('startDateBeforeEndDate')"> Start Date cannot be after End date</mat-error>
  </mat-form-field>
  <mat-checkbox
    class="checkbox-margin checkbox-text"
    color="primary"
    [formControl]="noEndDate"
    (change)="updatePresent()"
  >
    Present
  </mat-checkbox>
</div>
